import styled from '@emotion/styled';
import { auditIdMissionColors } from 'src/assets/colors';

export const AuditIdMissionWrapper = styled('div', { label: 'AuditIdMissionWrapper' })`
    width: calc(100% - 40px);
    height: calc(100% - 80px);
    margin: 60px 20px 20px 20px;
    background-color: ${auditIdMissionColors.wrapper.bgColor};
`;

export const AuditIdMissionHeader = styled('header', { label: 'AuditIdMissionHeader' })`
    padding: 20px;
    display: flex;
    align-items: center;
`;

export const AuditIdMissionTitle = styled('h3', { label: 'AuditIdMissionTitle' })`
    display: block;
    width: 50%;
`;

export const AuditIdMissionContainer = styled('div', { label: 'AuditIdMissionContainer' })`
    padding: 20px;
    overflow-x: auto;

    @media (max-width: 1120px) {
        padding: 20px 10px;
    }
`;

export const CloseButton = styled('button', { label: 'CloseButton' })`
    padding: 10px;
`;

export const AuditIdMissionTable = styled('table', { label: 'AuditIdMissionTable' })`
    width: 100%;
    border-collapse: collapse;
    
    th, td {
        padding: 8px 12px;
        text-align: left;
        border-bottom: 1px solid ${auditIdMissionColors.table.borderColor};
    }
    
    th {
        font-weight: 600;
        background-color: ${auditIdMissionColors.table.headerBgColor};
    }
    
    tbody {
        & > tr:nth-child(even){
            background-color: ${auditIdMissionColors.table.evenRowBgColor};
        }
    }
    
    @media (max-width: 1120px) {
        min-width: 1200px;

        th, td {
            white-space: nowrap;
        }

        td:last-child {
            min-width: 120px;
        }
    }
`;

export const JsonDetailsRow = styled('td', { label: 'JsonDetailsRow' })`
    padding-left: 40px;
    background-color: ${auditIdMissionColors.jsonDetails.rowBgColor};
`;

export const JsonDetailsContainer = styled('div', { label: 'JsonDetailsContainer' })`
    margin-top: 10px;
    margin-bottom: 10px;
`;

export const JsonDetailsTitle = styled('h4', { label: 'JsonDetailsTitle' })`
    margin: 0 0 10px 0;
    color: ${auditIdMissionColors.jsonDetails.titleColor};
    font-size: 14px;
`;

export const JsonDetailsContent = styled('pre', { label: 'JsonDetailsContent' })`
    background-color: ${auditIdMissionColors.jsonDetails.contentBgColor};
    padding: 10px;
    border-radius: 4px;
    overflow: auto;
    font-size: 12px;
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    max-height: 400px;
    min-height: 200px;
`;

export const ActionsContainer = styled('div', { label: 'ActionsContainer' })`
    display: flex;
    gap: 8px;
    flex-direction: row;
    white-space: nowrap;
`;

export const ButtonWrapper = styled('div', { label: 'ButtonWrapper' })`
    position: relative;
    display: inline-block;
`;

export const ButtonLoadingOverlay = styled('div', { label: 'ButtonLoadingOverlay' })<{ isLoading: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.1);
    display: ${(props): string => (props.isLoading ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
    border-radius: 4px;
`;

export const SpinnerContainer = styled('div', { label: 'SpinnerContainer' })`
    width: 20px;
    height: 20px;
`;

